import { LayoutBodyContainer } from '@ppay/client'
import styled from 'styled-components'

export const BodyContainer = styled(LayoutBodyContainer)`
  display: flex;
  align-items: center;
  flex-direction: column;
`
